// extracted by mini-css-extract-plugin
export default {"mainContainer":"RenewCancelLicenceModal_mainContainer__hY8Ps"};